module.exports = __webpack_public_path__ + "static/media/header@2x.98451925.jpg";